import { gql } from '@apollo/client';

import { PERMISSION_FRAGMENTS } from './permisssionFragment';

export const ROLE_FRAGMENTS = gql`
  fragment RoleFields on Role {
    id
    name
    description
    organizationId
    createdAt
    updatedAt
  }
`;

export const ROLE_WITH_PERMISSIONS_FRAGMENTS = gql`
  fragment RoleWithPermissionsFields on Role {
    id
    name
    description
    organizationId
    createdAt
    updatedAt
    userCount
    permissionCount
    permissions(pagination: { first: 100 }) {
      edges {
        node {
          ...PermissionFields
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
    users {
      id
      organizationId
      firstName
      lastName
      email
      description
      status
      isEmailVerified
      isOwner
      lastLoginAt
      createdAt
      updatedAt
      deletedAt
      fullName
    }
  }
  ${PERMISSION_FRAGMENTS}
`;
